module.exports = __webpack_public_path__ + "img/methoden_1920.28d863b2.png";